import React from 'react'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import CancelIcon from '@mui/icons-material/Cancel'
import { Grid } from '@mui/material'

type Props = {
  images: File[]
  setImages: (arg: File[]) => void,
  size: number,
  title:string
}

const FileUploader = (props: Props) => {
  const maxImagesUpload = props.size
  const inputId = Math.random().toString(32).substring(2)

  const handleOnAddImage = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return
    const files: File[] = []

    for (const file of e.target.files) {
      files.push(file)
    }

    props.setImages([...props.images, ...files])
    e.target.value = ''
  }

  const handleOnRemoveImage = (index: number) => {
    const newImages = [...props.images]
    newImages.splice(index, 1)
    props.setImages(newImages)
  }

  return (
    <>
      {(props.images.length === 1) ? <div style={{position:'relative'}}>
            <IconButton
              aria-label='delete image'
              style={{
                position:'absolute',
                top: -18,
                right: 89,
                color: '#aaa'
              }}
              onClick={() => handleOnRemoveImage(0)}
            >
              <CancelIcon />
            </IconButton>
            <img
              src={URL.createObjectURL(props.images[0])}
              style={{
                width: '120px',
                border:'1px dashed grey',
                borderRadius:'10px',
                height: '120px',
                objectFit: 'contain',
                aspectRatio: '1 / 1'
              }}
              alt=''
            />
      </div> : 
      <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 8, sm: 12, md: 12 }}>
        {props.images.map((image, i) => (
          <Grid
            item
            xs={4}
            sm={4}
            md={4}
            key={i}
            sx={{
              display: 'flex',
              justifyContent: 'start',
              alignItems: 'center',
              position: 'relative',
            }}
          >
            <IconButton
              aria-label='delete image'
              style={{
                position: 'absolute',
                top: 5,
                right: -18,
                color: '#aaa'
              }}
              onClick={() => handleOnRemoveImage(i)}
            >
              <CancelIcon />
            </IconButton>
            <img
              src={URL.createObjectURL(image)}
              style={{
                width: '100%',
                border:'1px dashed grey',
                borderRadius:'10px',
                height: '100%',
                objectFit: 'contain',
                aspectRatio: '1 / 1'
              }}
              alt=''
            />
          </Grid>
        ))}
      </Grid>}
      {(props.images.length >= maxImagesUpload) ? '' : 
      <label htmlFor={inputId}>
        <Button  size='small' className='c-dashed-button' variant='outlined' disabled={props.images.length >= maxImagesUpload} component='span' sx={{ mt: 4 }}>
          {props.title}
        </Button>
        <input
          id={inputId}
          type='file'
          multiple
          accept='image/*,.png,.jpg,.jpeg,.gif'
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnAddImage(e)}
          style={{ display: 'none' }}
        />
      </label>}
    </>
  )
}

export default FileUploader